import * as React from "react";
import {useState, useEffect, forwardRef, useImperativeHandle, useRef} from "react";

interface IProps {
    seconds: number;
    handleTrackTime?: (time: number) => void;
    handleTimeEnd?: () => void;
}

let timeInterval = null;

function formatTime(currentTime) {
    const minutes = Math.floor(currentTime / 60);
    const seconds = currentTime % 60;
    return `0${minutes} : ${seconds}`;
}

function Timer(props: IProps, ref) {
    const [timer , updateStartTime] = useState<number>(props.seconds);
    const timeRef = useRef(props.seconds);

    function startTimer() {
        timeInterval = setInterval(() => {
            const currentTime = timeRef.current - 1;
            updateStartTime(currentTime);
            if (props.handleTrackTime) {
                props.handleTrackTime(currentTime);
            }
            timeRef.current = currentTime;
            if (currentTime === 0) {
                clearInterval(timeInterval);
                if (props.handleTimeEnd) {
                    props.handleTimeEnd();
                }
            }
        }, 1000);
    }

    useImperativeHandle(ref, () => ({
        reStartTimer(time: number) {
            clearInterval(timeInterval);
            timeRef.current = time;
            startTimer();
        },
    }));

    useEffect(() => {
        startTimer();
        return () => {
            clearInterval(timeInterval);
        };
    }, []);

    return <b>{formatTime(timer)}</b>;
}
export default forwardRef(Timer);
